import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { CounterService } from './counter.service';
import { DatabaseService } from './database.service';
import { HelperService } from '.';
import { User } from "@sentry/angular-ivy";
import { equalTo, orderByChild } from '@angular/fire/database';

export interface IAppNotificationConfig {
  action: string;
  actionBy: string;
  actionDate: string;
  client: string;
  referenceId?: string;
  type: string;
  data?: any;
}


@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  public userActivityList: Observable<any>;
  public userActivityListSubscription: Subscription;
  public userActivities: any[];
  public userActivitySubject = new Subject<any>();

  constructor(
    private counterService: CounterService,
    private dbService: DatabaseService,
    private helperService: HelperService,
  ) { }

  public loadUserActivities(userId): void {
    this.userActivityList = this.getUserActivityList(userId);
    this.userActivityListSubscription = this.userActivityList.subscribe(snap => {
      const list = this.helperService.transformFirebaseObjectToArray(snap);
      const activities = [];
      let unread = 0;
      for (const item of list) {
       activities.push(item);
       if(item.read === false) {
        unread++;
       }
      }
      this.counterService.setCounter("unreadActivities", unread);
      this.userActivities = activities;
      this.publishUserActivitySubject();
    });
  }

  private publishUserActivitySubject() {
    this.userActivitySubject.next(this.userActivities);
  }

  public getUserActivitySubject(): Subject<any> {
    return this.userActivitySubject;
  }

  public getUserActivityList(userId: string) {
    return this.dbService.getListByRefTest(`notifications/${userId}`);
  }

  updateActivity(userId: string, activityId: string, updateObj: any) {
    return this.dbService.updateRef(`/notifications/${userId}/${activityId}`, updateObj);
  }

  public clearUserActivities() {
    this.userActivities = null;
    this.userActivityList = null;
    if(this.userActivityListSubscription) {
      this.userActivityListSubscription.unsubscribe();
    }
  }

  public deleteUserActivity(userId: string, activityId: string) {
    return this.dbService.removeRef(`notifications/${userId}/${activityId}`);
  }

  public undoDeleteUserACtivity(userId, activityId, activity) {
    return this.dbService.setRef(`notifications/${userId}/${activityId}`, activity);
  }

  async clearNotificationByReference(userId: string, referenceId: string) {
    const snap = await this.dbService.getSnapshot(`notifications/${userId}`, orderByChild('referenceId'), equalTo(referenceId));
    if(snap) {
      const notifications = this.helperService.transformFirebaseObjectToArray(snap);
      for (const noti of notifications) {
        if(!noti.read) {
          this.updateActivity(userId, noti.id, {
            read: new Date().toISOString()
          }).then(succ => {}).catch(err => {});
        }
      }
    }
  }

  async createAppNotification(userId: string, notificationConfig: IAppNotificationConfig, actionBy: User): Promise<any> {
    let actionUser: any = null;
    if(notificationConfig.actionBy) {
      actionUser = {};
      if(notificationConfig.actionBy === "system") {
         actionUser.type = "system";
      } else {
        actionUser.type = "user";
        actionUser.id = notificationConfig.actionBy;
        actionUser.name = `${actionBy.firstName} ${actionBy.lastName}`;
      }
    }
    
    return this.dbService.pushByRef(`notifications/${userId}`, {
      ...notificationConfig,
      actionUser: actionUser,
      read: false
    });
  };
}
